module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [(_vm.type === 'IMS') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Static"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igStatic ? _vm.data.igStatic : '-')))])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Carousel"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igCarousel ? _vm.data.igCarousel : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Story"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igStory ? _vm.data.igStory : '-')))])]), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Post"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igPost ? _vm.data.igPost : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Reel"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igReel ? _vm.data.igReel : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'IMS') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      Blog"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.blog ? _vm.data.blog : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_vm._v("\n      Event Appearance "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.eventAppearance ? _vm.data.eventAppearance : '-')))])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      Tiktok"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.tiktok ? _vm.data.tiktok : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Loading Fee"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.loadingFee ? _vm.data.loadingFee : '-')))])])], 1), _vm._v(" "), _c('v-row'), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      IG Remarks"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igRemarks ? _vm.data.igRemarks : '-')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Tiktok Remarks"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.tiktokRemarks ? _vm.data.tiktokRemarks : '-')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'IMS') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Remark"), _c('br'), _vm._v(" "), (_vm.data.remark) ? _c('strong', [_vm._v(_vm._s((_vm.data.remark ? _vm.data.remark : '-')))]) : _vm._e(), _vm._v(" "), (_vm.data.remarks) ? _c('strong', [_vm._v(_vm._s((_vm.data.remarks ? _vm.data.remarks : '-')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.data.pricingDecks && _vm.data.pricingDecks.length > 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Pricing Decks")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.data.pricingDecks
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e5a2b88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/RateCard/Preview.vue
// module id = 2220
// module chunks = 0